import { useMemo } from 'react'

import { BASE_BLOCKS, type Block, UploadLeadsConfig, type ULStepName, type StepItem } from '../constants/ul-config'

type StepMap = Partial<Record<ULStepName, StepItem>>

const buildStepsForFlow = (sourceSteps: StepMap): StepMap => {
  const flowSteps: StepMap = {}
  const orderedStepKeys = Object.keys(sourceSteps) as ULStepName[]

  for (const stepKey of orderedStepKeys) {
    const step = sourceSteps[stepKey]
    if (!step) continue

    flowSteps[stepKey] = {
      ...step,
      progress: {
        ...step.progress,
        step: step.progress.step - 1,
      },
    }
  }

  return flowSteps
}

/**
 * We can update the blocks if we need condition block visibility logic.
 * For example, if we need to show the block only if the user has uploaded a file, we can update the block here.
 */
const buildBlocksForFlow = (sourceBlocks: Block[]): Block[] => {
  const flowBlocks: Block[] = []

  for (const block of sourceBlocks) {
    flowBlocks.push({
      ...block,
    })
  }

  return flowBlocks
}

const useUploadLeadsConfig = () => {
  const config = useMemo(() => {
    const sourceConfig = UploadLeadsConfig
    const flowSteps = buildStepsForFlow(sourceConfig.steps)

    return {
      ...sourceConfig,
      steps: flowSteps,
      totalSteps: Object.keys(flowSteps).length,
    }
  }, [])

  const totalSteps = config.totalSteps

  const blocks = useMemo(() => {
    const sourceBlocks = BASE_BLOCKS
    return buildBlocksForFlow(sourceBlocks)
  }, [])

  return { config, blocks, totalSteps }
}

export default useUploadLeadsConfig
